import React, { useEffect, useRef, useState } from "react";
import Image from "next/image";
import styles from "./FeeRange.module.scss";
import fee from "../../assets/images/feerange.png";
import HtmlPopup from "../HtmlPopup";
import { useRouter } from "next/router";

const FeeRange = ({ data, ctaPopupData }) => {

  const router = useRouter();
  const { slug } = router?.query;

  const [displayPopup, setDisplayPopup] = useState(false);
  const title = ctaPopupData?.feeCta?.ctapopuptitle;
  const content = ctaPopupData?.feeCta?.ctapopup?.content?.[0]?.content?.[0]?.text

  const containerRef = useRef<HTMLDivElement>(null);
  
  useEffect(() => {
    const interval = setInterval(() => {
      if (slug !== "cranleigh-abu-dhabi"){
        clearInterval(interval);
      }
      const container = containerRef.current;
      if (!container) return;
      const buttonEl = container.querySelector("#cta-crangleigh-school-fee");
      if (buttonEl) {
        const handleClick = (e) => {
          e.preventDefault();
          openPopUp();   
        };
        buttonEl.addEventListener("click", handleClick);
        clearInterval(interval);
      }
    }, 100);
  
    return () => {
      clearInterval(interval);
      const container = containerRef.current;
      if (container) {
        const buttonEl = container.querySelector("#cta-crangleigh-school-fee");
        if (buttonEl) {
          buttonEl.removeEventListener("click", openPopUp);
        }
      }
    };
  }, [data]);
    
  const openPopUp = () => {
    setDisplayPopup(true);
  }

  
  return (
    <>
      {data && (
        <div
          className="container sec_padding freerange-sec"
          data-testid="feerange-container-id"
        >
          <div className={styles.fee_range_main}>
            <div className={styles.image_container}>
              <Image src={fee} alt="fee" className={styles.bg_img} />
              <div className={styles.overlay}>
                <div
                  ref={containerRef}
                  className={styles.column}
                  dangerouslySetInnerHTML={{
                    __html: data?.description?.content?.[0]?.content?.[0]?.text,
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      )}
      {
        displayPopup 
        && ctaPopupData 
        && <HtmlPopup
          showPopup={displayPopup}
          setShowPopup={setDisplayPopup}
          title = {title}
          htmlContent={content}
        />
      }
    </>
  );
};

export default FeeRange;
